import {
  Input,
  Output,
  OnDestroy,
  Component,
  EventEmitter,
} from '@angular/core';

@Component({
  selector: 'tablesready-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss'],
})
export class TabsComponent implements OnDestroy {
  @Input() showBorder = true;
  @Input() tabs: string[] = [];
  @Input() activeTab: string;
  @Input() boldText = false;
  @Input() disabled = false;
  @Output() changeTab = new EventEmitter<string>();

  ngOnDestroy(): void {
    this.changeTab.complete();
  }

  changeNav(tab: string): void {
    if (!this.disabled) {
      this.changeTab.emit(tab);
    }
  }

  isActiveTab(tab: string): boolean {
    return tab === this.activeTab;
  }
}
